import api from './api';

export interface PatientStatusConfig {
  id: number;
  key: string;
  title: string;
  can_schedule_meeting: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface PatientStatusConfigCreate {
  key: string;
  title: string;
  can_schedule_meeting?: boolean;
}

export interface PatientStatusConfigUpdate {
  key?: string;
  title?: string;
  can_schedule_meeting?: boolean;
}

const patientStatusConfigService = {
  getAll: async (tenantId: number): Promise<PatientStatusConfig[]> => {
    const response = await api.get('/patient-status-configs/', { params: { tenant_id: tenantId } });
    return response.data;
  },
  create: async (tenantId: number, data: PatientStatusConfigCreate): Promise<PatientStatusConfig> => {
    const response = await api.post(`/patient-status-configs/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  update: async (id: number, data: PatientStatusConfigUpdate): Promise<PatientStatusConfig> => {
    const response = await api.put(`/patient-status-configs/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/patient-status-configs/${id}`);
  },
};

export default patientStatusConfigService;
